import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import Popup from 'reactjs-popup';
import Cookies from 'universal-cookie';

export default function WebinarModal({ 
}) {
    const cookies = new Cookies();
    const router = useRouter()

    const [open, setOpen] = useState(false);
    const closeModal = () => {
        setOpen(false);
        
        cookies.set('webinarModal', true, {
            expires: new Date(new Date().getTime() + (3*60*60*1000))
        });
    }
    
    useEffect(() => {
        if(! cookies.get('webinarModal') && router.pathname == '/succesverhalen') {
            const timeId = setTimeout(() => setOpen(true), 5000);

            return () => clearTimeout(timeId);
        }
    }, []); 

    return (
        <div suppressHydrationWarning={true}>
            {process.browser && (
                <Popup open={open} closeOnDocumentClick onClose={closeModal}>
                    <div className="modal-ebook">
                        <button className="close" onClick={closeModal}>
                        &times;
                        </button>
                        <div className="header"> 
                            <h3>Gratis masterclass</h3>
                        </div>

                        <div className="content">
                            Wil jij weten hoe deze mensen hun klachten hebben opgelost?

                            <img 
                                height="200"
                                src="/img/masterclass.jpg" 
                            />
                        </div>
                        <div className="actions">
                            <a
                                href="https://pijnresetcommunity.nl/gratis-masterclass/"
                                target="_blank"
                                className="mt-0 btn btn-orange"
                                onClick={closeModal}
                            >
                                Bekijk gratis webinar
                            </a>
                        </div>
                    </div>
                </Popup>
            )}
        </div>
    )
}
